import { getActiveEnvProfile } from "@/utils/utils";
import { Layout } from "antd";
import { Outlet } from "react-router";

export const PublicLayout = () => {
  return (
    <Layout className={getActiveEnvProfile()} style={{ minHeight: "100svh" }}>
      <Layout.Content style={{ padding: "16px 16px 24px" }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
